import React from "react";
import { Img, MediaKey } from "./Img";

export const ReferenceImage = (props: {
    noGrayscale?: boolean;
    src: MediaKey
    alt?: string;
    twScale?: string;
    className?: string;
}) => {
    return (
        <div className={`py-2 ${props.className} ${!props.noGrayscale && "grayscale"}`}>
            <Img
                size="xxs"
                className={`object-contain w-full h-full max-h-[20px] print:opacity-60 print:p-0.5 ${props.twScale}`}
                alt={props.alt ?? "reference"}
                src={props.src}
            />
        </div>
    );
};
